<template>
<div class="baselist-container">
  <ToolBar
    :handleToolSide="handleToolSide"
    :handleToolHeadBtn="handleToolHeadBtn"
    :title="title"
    :toolbarIcon="toolbarIcon"
    :toolbarColor="toolbarColor"
    :isLoading="isLoading"
  >
      <v-spacer></v-spacer>
      <ToolbarActions :actions="listActions" />
      <!-- <ViewSelector
        :hasList="true"
        :hasLine="true"
        :value="listView"
        :selectView="selectView" /> -->
  </ToolBar>

  <glistcontainer
    :key="`${source}-stats`"
    :source="source"
    :list="doc.list"
    :context="listContext"
    />

    <Popup
      :key="`${source}-stats-search-dialog`"
      v-if="searchDialog"
      :dialog="searchDialog"
      :handleSave="handleSearch"
      :handleClose="handleSearchClose"
      :handleReset="handleSearchReset"
    >
      <DataForm
        :key="`${source}-stats-search-dialog-form`"
        :fields="doc.list.search"
        :form="search"
        :updateField="updateSearchField"
      />
    </Popup>
</div>
</template>

<script>
import ListContainer from '@/containers/ListContainer'
import Popup from '@/components/Popup'
import DataForm from '@/components/form/DataForm'
import ToolBar from '@/components/ToolBar'
import ToolbarActions from '@/components/ToolbarActions'
import ViewSelector from '@/components/ViewSelector'
import { filterActions } from '@/utils'

export default {
  components: {
    glistcontainer: ListContainer,
    DataForm,
    ToolBar,
    Popup,
    ToolbarActions,
    ViewSelector,
  },
  data: () => ({
    toolbarIcon: 'home',
  }),
  computed: {
    dataList () { return this.$store.getters[`${this.source}/list`] },
    toolbarColor () { return this.hasError ? 'red darken-3' : 'blue darken-3' },
    isLoading () { return this.$store.getters[`${this.source}/isLoading`] },
    doc () { return this.$store.getters[`${this.source}/doc`] },
    scope () { return this.$store.getters['auth/scope'] },
    search () { return this.$store.getters[`${this.source}/search`] },
    searchDialog () { return this.search.dialog },
    listView () { return this.$store.getters[`${this.source}/listView`] },
    listContext () {
      return {
        params: {
          ...this.doc.params.fetchAll,
        },
        hasLine: true,
        hasCard: false,
      }
    },
    listActions () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      let filtered = filterActions(this.doc.list.actions, {}, this.scope)
      return filtered.map(action => ({
        ...action,
        callBack: () => { this.$store.dispatch(action.dispatch, payload) },
      }))
    },
    title () { return this.error ? this.errorMessage : this.doc.list.name },
  },
  methods: {
    refresh () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: this.search.data,
      }
      this.$store.dispatch(`${this.source}/fetchAll`, payload)
    },
    handleSearch () {
      this.refresh()
      this.handleSearchClose()
    },
    handleSearchClose () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/closeSearch`, payload)
    },
    handleSearchReset () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/resetSearch`, payload)
    },
    updateSearchField (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSearchField`, payload)
    },
    selectView (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/setListView`, payload)
    },
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      this.$router.push({path: '/'})
    },
  },
  props: {
    source: String,
    error: Boolean,
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    console.log(this.source, this.label)
    // don't forget to call next()
    next()
  },
  beforeMount () {
    if (!this.error) {
      this.refresh()
    }
  },
}
</script>

<style scoped>
  .baselist-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
  /* .progress-linear {
    margin: 0 !important;
  } */
</style>
